module.exports = __webpack_public_path__ + "img/foot-logo.62dd6694.png";